
export const openProd = (link: string) => {
    window.open(link)
}

